<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiDelete } from "@mdi/js";
export default {
  name: "MdiDelete",
  data() {
    return {
      svgPath: mdiDelete,
    };
  },
};
</script>
